/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ComputedSource } from '../../models/computed-source';
import { TagComputedCreate } from '../../models/tag-computed-create';

export interface CreateTagComputed$Params {

/**
 * the computed tag source type
 */
  source?: ComputedSource;
      body: TagComputedCreate
}

export function createTagComputed(http: HttpClient, rootUrl: string, params: CreateTagComputed$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createTagComputed.PATH, 'post');
  if (params) {
    rb.query('source', params.source, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createTagComputed.PATH = '/tags-computed';
